export function StatusDot({ online, status }) {
  const isSetup = status === "SETUP";
  const color = isSetup ? "bg-amber-400" : online ? "bg-emerald-400" : "bg-red-400";
  const text = isSetup ? "text-amber-400" : online ? "text-emerald-400" : "text-red-400";
  const label = isSetup ? "Setup" : online ? "Online" : "Offline";
  return (
    <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest" data-testid={`status-dot-${label.toLowerCase()}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${color} ${online && !isSetup ? "animate-pulse" : ""}`} />
      <span className={text}>{label}</span>
    </span>
  );
}

export function StatCard({ label, value, sub, tone = "text-slate-100", testid }) {
  return (
    <div className="panel px-4 py-3 hover:border-cyan-500/40 transition-colors duration-200" data-testid={testid}>
      <div className="mono-label !text-[9px]">{label}</div>
      <div className={`font-display text-xl font-bold tracking-tight mt-0.5 ${tone}`}>{value}</div>
      {sub ? <div className="text-[11px] text-slate-300 mt-0.5">{sub}</div> : null}
    </div>
  );
}

export function PageHeader({ title, sub, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-100">{title}</h1>
        {sub ? <p className="text-sm text-slate-300 mt-1">{sub}</p> : null}
      </div>
      {children ? <div className="flex items-center gap-2">{children}</div> : null}
    </div>
  );
}

export function EmptyState({ text, testid }) {
  return (
    <div className="panel p-10 text-center" data-testid={testid}>
      <div className="font-mono text-xs uppercase tracking-widest text-slate-400">{text}</div>
    </div>
  );
}

const CMD_TONES = {
  QUEUED: "text-amber-400 border-amber-400/30 bg-amber-400/10",
  PENDING: "text-amber-400 border-amber-400/30 bg-amber-400/10",
  DELIVERED: "text-blue-400 border-blue-400/30 bg-blue-400/10",
  DOWNLOADING: "text-blue-400 border-blue-400/30 bg-blue-400/10",
  ACKED: "text-cyan-400 border-cyan-400/30 bg-cyan-400/10",
  APPLYING: "text-cyan-400 border-cyan-400/30 bg-cyan-400/10",
  SUCCESS: "text-emerald-400 border-emerald-400/30 bg-emerald-400/10",
  FAILED: "text-red-400 border-red-400/30 bg-red-400/10",
};

export function CommandStatusChip({ status }) {
  return (
    <span className={`inline-block px-2 py-0.5 rounded-sm border font-mono text-[10px] uppercase tracking-widest ${CMD_TONES[status] || "text-slate-400 border-slate-600"}`}>
      {status}
    </span>
  );
}
